import { render, staticRenderFns } from "./ExpansaoTexto.vue?vue&type=template&id=04b56d70&scoped=true"
import script from "./ExpansaoTexto.vue?vue&type=script&lang=js"
export * from "./ExpansaoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b56d70",
  null
  
)

export default component.exports